import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Card, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  PaginationComponent,
} from "../../../components/Component";
import { PendingRequestsTable } from "../../../components/table/SpecialTable";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { getCurrencyIcon } from "../../../utils/getCurrencyIcon";
import { Document, Page } from "react-pdf";

export const HandledRequests = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [requests, setRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [modal, setModal] = useState({ view: false });
  const [search, setSearch] = useState("");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    searchAllPendingRequests(e.target.value)
  };

  // const debouncedSearchTerm = useDebounce(search, 500);

  // useEffect(
  //   () => {
  //     // if (debouncedSearchTerm) {
  //     getAllPendingRequests();
  //     setCurrentPage(1);
  //     // }v
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [debouncedSearchTerm] // Only call effect if debounced search term changes
  // );

  const getAllRequests = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/request-centre/get-all-approved-or-declined-requests?admin-usage=ADMIN_TREASURY`,
        {
          headers: authHeader(),
        }
      );
      const { data } = response;
      if (data) {
        // console.log("all requests", data)
        setRequests(data?.data?.content);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };


  const searchAllPendingRequests = async (param) => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/request-centre/pending-requests/find-by-param?param=${param}`,
        {
          headers: authHeader(),
        }
      );
      const { data } = response;
      if (data) {
        setRequests(data?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const onFormCancel = () => {
    setModal({ view: false });
  };

  // const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllRequests();
  }, []);

  const onViewClick = (item) => {
    setSelectedRequest(item);
    setModal({ view: true });
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = requests?.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fileExtension = (url) => {
    const rurl = url.split(".").pop();
    console.log(rurl);
    return rurl;
  };

  return (
    <React.Fragment>
      <Head title="Handled Requests"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Handled Requests</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div>
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Request..."
                    />
                  </div>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview" style={{ width: "100%", overflowX: "auto" }}>
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <PendingRequestsTable onViewClick={onViewClick} data={currentItems} />
            )}
          </Card>
          <div className="card-inner">
            {requests && requests.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={requests?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Request found</span>
              </div>
            )}
          </div>
        </Block>
        <Modal size="lg" isOpen={modal.view} toggle={() => setModal({ view: false })}>
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Request Details</h5>
              <Col md="12" className="w-100 d-flex justify-content-between p-0 my-2">
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Customer Name:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.customerName ?? "N/A"} </span>
                </Col>
              </Col>
              <Col md="12" className="w-100 d-flex justify-content-between p-0 my-2">
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Email:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.requester?.email ?? "N/A"} </span>
                </Col>
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Phone:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.requester?.phone ?? "N/A"} </span>
                </Col>
              </Col>
              <Col md="12" className="w-100 d-flex justify-content-between p-0 my-2">
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Request Type:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.requestType ?? "N/A"} </span>
                </Col>
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Request Status:
                  </span>
                  <span
                    style={{ fontSize: "0.9rem" }}
                    className={`badge badge-dot badge-${
                      selectedRequest?.requestStatus === "APPROVED"
                        ? "success"
                        : selectedRequest?.requestStatus === "PENDING"
                        ? "warning"
                        : "danger"
                    }`}
                  >
                    {selectedRequest?.requestStatus}
                  </span>
                </Col>
              </Col>
              <Col md="12" className="w-100 d-flex justify-content-between p-0 my-2">
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Product Name:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.product?.productName ?? "N/A"} </span>
                </Col>
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Plan Name:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.plan?.planName ?? "N/A"} </span>
                </Col>
              </Col>
              <Col md="12" className="w-100 d-flex justify-content-between p-0 my-2">
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Last Action Date:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.lastActionDate ?? "N/A"} </span>
                </Col>
              </Col>
              <Col md="12" className="w-100 d-flex justify-content-between p-0 my-2">
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Requester:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.customerName}</span>
                </Col>
                {
                  selectedRequest?.accountNumber && (
                    <Col md="6" className="p-0">
                      <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                        Account Number:
                      </span>
                      <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.accountNumber}</span>
                    </Col>
                  )
                }
              </Col>
              <Col md="12" className="mt-2 w-100 d-flex justify-content-between p-0">
                {
                  selectedRequest?.accountNumber && (
                    <Col md="6" className="p-0">
                      <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                        Bank Name:
                      </span>
                      <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.bankName}</span>
                    </Col>
                  )
                }
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Transaction Amount:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>
                    {selectedRequest?.transactionAmount
                      ? `${getCurrencyIcon(
                          selectedRequest?.plan?.currency?.name
                        )} ${selectedRequest?.transactionAmount.toLocaleString('en-US')}`
                      : "N/A"}
                  </span>
                </Col>
              </Col>
              <Col md="12" className="mt-2 w-100 d-flex justify-content-between p-0">
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Investment Amount:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>
                    {selectedRequest?.investmentAmount
                      ? `${getCurrencyIcon(selectedRequest?.plan?.currency?.name)} ${
                          selectedRequest?.investmentAmount
                        .toLocaleString('en-US')}`
                      : "N/A"}{" "}
                  </span>
                </Col>
                <Col md="6" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Expected Interest Return:
                  </span>
                  <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.expectedInterestReturn ?? "N/A"} </span>
                </Col>
              </Col>
              <Col md="12" className="mt-2 w-100 d-flex justify-content-between p-0">
                <Col md="6" className="p-0">
                    <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                      Maturity Date:
                    </span>
                    <span style={{ fontSize: "0.9rem" }}>{selectedRequest?.maturityDate ?? "N/A"} </span>
                  </Col>
              </Col>
              <Col md="12" className="w-100 d-flex justify-content-between p-0 my-2">
                <Col md="12" className="p-0">
                  <span style={{ fontSize: "1rem" }} className="font-weight-bold mr-1">
                    Stages:
                  </span>
                  <div className="w-100">
                    {selectedRequest?.processFlowOutDto?.stage.length > 0 ? (
                      selectedRequest?.processFlowOutDto?.stage.map((stage) => (
                        <Col md="12">
                          <span style={{ fontSize: "0.9rem" }} className="font-weight-bold mr-1">
                            Approval Required ({stage?.stage?.stageName ?? "N/A"}):
                          </span>
                          <span style={{ fontSize: "0.8rem", marginRight: "0.8rem" }}>
                            {stage?.stage?.role?.roleName ?? "N/A"}{" "}
                          </span>
                          {stage?.stage?.role?.id === selectedRequest?.departmentToApprove?.id && (
                            <span className="text-warning"> [current stage]</span>
                          )}
                        </Col>
                      ))
                    ) : (
                      <div>
                        <p>No Stage Found</p>
                      </div>
                    )}
                  </div>
                </Col>
              </Col>
              {selectedRequest?.attachedDocument3 && (
                <>
                  <Col>
                    <h6 className="font-weight-bold mt-3 mb-3">Uploaded Documents</h6>
                  </Col>

                  {fileExtension(selectedRequest?.attachedDocument3) !== "pdf" && (
                    <Col md="5" className="mt-2 w-100 d-flex justify-content-between p-0">
                      <img src={selectedRequest?.attachedDocument3} style={{ width: "100%" }} alt="attached-document" />
                    </Col>
                  )}
                  <Button onClick={() => window.open(selectedRequest?.attachedDocument3, "_blank").focus()}>
                    View Uploaded Document [{fileExtension(selectedRequest?.attachedDocument3)}]
                  </Button>
                </>
              )}
              {selectedRequest?.attachedDocument4 && (
                <>
                  <Col>
                    <h6 className="font-weight-bold mt-3 mb-3">Uploaded Documents</h6>
                  </Col>

                  {fileExtension(selectedRequest?.attachedDocument4) !== "pdf" && (
                    <Col md="5" className="mt-2 w-100 d-flex justify-content-between p-0">
                      <img src={selectedRequest?.attachedDocument4} style={{ width: "100%" }} alt="attached-document" />
                    </Col>
                  )}
                  <Button onClick={() => window.open(selectedRequest?.attachedDocument4, "_blank").focus()}>
                    View Uploaded Document [{fileExtension(selectedRequest?.attachedDocument4)}]
                  </Button>
                </>
              )}
              {selectedRequest?.withdrawalInstructionImage && (
                <>
                  <Col>
                    <h6 className="font-weight-bold mt-3 mb-3">Uploaded Withdrawal Instruction Document</h6>
                  </Col>

                  {fileExtension(selectedRequest?.withdrawalInstructionImage) !== "pdf" && (
                    <Col md="5" className="mt-2 w-100 d-flex justify-content-between p-0">
                      <img
                        src={selectedRequest?.withdrawalInstructionImage}
                        style={{ width: "100%" }}
                        alt="attached-document"
                      />
                    </Col>
                  )}
                  <Button onClick={() => window.open(selectedRequest?.withdrawalInstructionImage, "_blank").focus()}>
                    View Uploaded Document [{fileExtension(selectedRequest?.withdrawalInstructionImage)}]
                  </Button>
                </>
              )}
              {selectedRequest?.withdrawalMandateLetter && (
                <>
                  <Col>
                    <h6 className="font-weight-bold mt-3 mb-3">Uploaded Withdrawal Mandate Document</h6>
                  </Col>

                  {fileExtension(selectedRequest?.withdrawalMandateLetter) !== "pdf" && (
                    <Col md="5" className="mt-2 w-100 d-flex justify-content-between p-0">
                      <img
                        src={selectedRequest?.withdrawalMandateLetter}
                        style={{ width: "100%" }}
                        alt="attached-document"
                      />
                    </Col>
                  )}
                  <Button onClick={() => window.open(selectedRequest?.withdrawalMandateLetter, "_blank").focus()}>
                    View Uploaded Document [{fileExtension(selectedRequest?.withdrawalMandateLetter)}]
                  </Button>
                </>
              )}
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
